import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    TextField, Card, CardContent, Typography, Stack, Grid, Chip, TableContainer, Divider
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search as SearchIcon } from "@mui/icons-material";

// ==========================================
// THEME CHUẨN (ĐÃ ĐỒNG BỘ FONT PLUS JAKARTA SANS)
// ==========================================
const minimalistTheme = createTheme({
    palette: {
        background: { default: "#F9F9F9", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#A1A5B7" }, 
        primary: { main: "#2563EB", light: "#EFF6FF" }, 
        success: { main: "#16A34A", light: "#DCFCE7" }, 
        danger: { main: "#EF4444", light: "#FEE2E2" },  
        warning: { main: "#F59E0B", light: "#FEF3C7" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: {
            styleOverrides: {
                root: { borderRadius: "12px", border: "1px solid #EFF2F5", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.02)" }
            }
        },
        MuiTable: {
            styleOverrides: { root: { border: "none !important", borderCollapse: "collapse !important" } }
        },
        MuiTableCell: {
            styleOverrides: {
                root: { 
                    borderBottom: "1px solid #EFF2F5 !important", 
                    padding: "14px 12px", 
                    color: "#3F4254", 
                    fontSize: "0.85rem",
                    fontFamily: "'Plus Jakarta Sans', sans-serif !important",
                    backgroundColor: "transparent !important" 
                }
            }
        }
    }
});

function AllEmployee() {
    const navigate = useNavigate();

    // ==========================================
    // KIỂM TRA QUYỀN TRUY CẬP NGAY KHI VÀO TRANG
    // ==========================================
    useEffect(() => {
        const profile = JSON.parse(localStorage.getItem("profile"));
        const isFullAdmin = profile?.permission?.full === 1;
        const pRoles = profile?.roles || {};

        if (!isFullAdmin && !pRoles.user_admin) {
            swal("Cảnh báo", "Bạn không có quyền truy cập trang quản lý nhân viên/đại lý!", "warning");
            navigate("/admin"); 
        }
    }, [navigate]);

    // 🟢 DANH SÁCH CÁC QUYỀN GIỮ NGUYÊN TÊN ROLE_LIST (ĐÃ PHÂN THEO CÁC MỤC GIAO DIỆN)
    const ROLE_LIST = [
        {
            category: "Tổng quan & Người dùng",
            roles: [
                { name: 'dashboard', label: 'Tổng Quan' },
                { name: 'user_customer', label: 'DS Khách Hàng' }, 
                { name: 'user_admin', label: 'DS Nhân Viên' }
            ]
        },
        {
            category: "Giao dịch",
            roles: [
                { name: 'recharge', label: 'Nạp Tiền' }, 
                { name: 'withdraw', label: 'Rút Tiền' }
            ]
        },
        {
            category: "Quản lý trò chơi",
            roles: [
                { name: 'game_tx45', label: 'Tài Xỉu 45s' }, { name: 'game_tx60', label: 'Tài Xỉu 60s' },
                { name: 'game_xd45', label: 'Xóc Đĩa 45s' }, { name: 'game_xd60', label: 'Xóc Đĩa 60s' },
                { name: 'game_xs75', label: 'Xổ Số 75s' }, { name: 'game_xs120', label: 'Xổ Số 120s' },
                { name: 'game_baccarat', label: 'Baccarat' } // THÊM QUYỀN BACCARAT VÀO ĐÂY
            ]
        },
        {
            category: "Lịch sử",
            roles: [
                { name: 'hist_bet', label: 'Lịch Sử Cược' }, 
                { name: 'hist_api', label: 'Lịch Sử API' }, 
                { name: 'hist_refund', label: 'Hoàn Trả' }
            ]
        },
        {
            category: "Cấu hình hệ thống",
            roles: [
                { name: 'sys_promo', label: 'Mã Khuyến Mãi' }, { name: 'sys_notify', label: 'Thông Báo' },
                { name: 'sys_withdraw', label: 'Rút Quỹ Hệ Thống' }, { name: 'sys_odds', label: 'Tỷ Lệ Cược' },
                { name: 'sys_vip', label: 'Cấp Độ VIP' }, { name: 'sys_bank', label: 'Ngân Hàng' }, 
                { name: 'sys_config', label: 'Cấu Hình Chung' }
            ]
        }
    ];

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${d.getUTCFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)}  ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const [users, setUser] = useState(null);
    const [nhanvien, setNhanvien] = useState(null);
    const [load, setLoad] = useState(false);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [searched, setSearched] = useState("");
    const [type, setType] = useState("customer");
    
    // State lưu quyền lúc TẠO MỚI
    const [roles, setRoles] = useState({});
    
    // State lưu quyền lúc CHỈNH SỬA (Modal)
    const [editRoles, setEditRoles] = useState({});

    const [data2, setData2] = useState(null);
    
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        if (load === false) {
            axios.get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, {})
                .then((res) => {
                    if (res.data.data) setData2(res.data.data);
                    setUser(res.data.data);
                });
            axios.get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, {params: {keyword:"nhanvien"}})
                .then((res) => {
                    setNhanvien(res.data.data);
                    setLoad(true);
                });
        }
    }, [load]);

    const requestSearch = (e) => {
        const searchedVal = e.target.value;
        setSearched(searchedVal);
        if (searchedVal !== "") {
            const filteredRows = data2.filter((row) => {
                const a = row?.username.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const b = Number(row.iduser).toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                return a || b;
            });
            setUser(filteredRows);
        } else {
            setUser(data2);
        }
    };

    const handleChange = (e) => {
        setType(e.target.value);
        if (e.target.value !== "admin") {
            setRoles({});
        }
    };

    const handleRoleChange = (e) => {
        setRoles({ ...roles, [e.target.name]: e.target.checked });
    };

    const handleEditRoleChange = (e) => {
        setEditRoles({ ...editRoles, [e.target.name]: e.target.checked });
    };

    const handleApproveAgent = (user) => {
        if (!user.subdomain) return swal("Lỗi", "Đại lý này chưa có tên Subdomain", "error");

        const subPrefix = user.subdomain.split('.')[0]; 

        swal({
            title: "Xác nhận duyệt?",
            text: `Hệ thống sẽ tạo tên miền ${user.subdomain} và kích hoạt đại lý này.`,
            icon: "warning",
            buttons: ["Hủy", "Duyệt Ngay"],
        }).then((willApprove) => {
            if (willApprove) {
                axios.post("https://cpanel.vz88.vin/api_cloudflare.php", { sub_prefix: subPrefix })
                .then((phpRes) => {
                    if (phpRes.data && phpRes.data.success) {
                        axios.post(`${process.env.REACT_APP_API_URL}/auth/approveAgent`, { id: user._id })
                        .then(() => {
                            swal("Thành công", "Đã duyệt và tạo Subdomain thành công!", "success").then(() => window.location.reload());
                        })
                        .catch(() => swal("Cảnh báo", "Đã tạo Subdomain nhưng lỗi cập nhật CSDL", "warning"));
                    } else {
                        swal("Lỗi Cloudflare", phpRes.data.message, "error");
                    }
                })
                .catch(() => swal("Lỗi", "Không thể kết nối đến API Cloudflare", "error"));
            }
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const username = e.target.username.value;
        const password = e.target.password.value;
        const code = e.target.code.value;
        const subdomainVal = e.target.subdomain ? e.target.subdomain.value : "";

        const formData = {
            username: username, password: password, code: code, type: type,
            subdomain: subdomainVal,
            roles: type === 'admin' ? roles : {}
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/createEmployee`, formData)
            .then((res) => {
                if (subdomainVal && subdomainVal.trim() !== "") {
                    axios.post("https://cpanel.vz88.vin/api_cloudflare.php", { sub_prefix: subdomainVal.trim() })
                    .then((phpRes) => {
                        if (phpRes.data && phpRes.data.success) {
                            swal(t('success'), `Tạo tài khoản và Subdomain thành công!`, "success").then(() => window.location.reload());
                        } else {
                            swal("Cảnh báo", `Tạo tài khoản thành công nhưng lỗi Subdomain: ${phpRes.data.message}`, "warning");
                        }
                    })
                    .catch(() => swal("Cảnh báo", "Tạo tài khoản thành công nhưng không thể kết nối tới API Subdomain.", "warning"));
                } else {
                    swal(t('success'), "Tạo tài khoản thành công!", "success").then(() => window.location.reload());
                }
                e.target.reset();
            })
            .catch(() => swal(t('error'), "Lỗi khi tạo tài khoản", "error"));
    };

    const handleSubmitLs = (e) => {
        e.preventDefault();
        const formData = {
            id: ls._id,
            roles: editRoles
        };
        
        axios.post(`${process.env.REACT_APP_API_URL}/auth/updateRoles`, formData)
            .then(() => { 
                setShow(false); 
                swal(t('success'), "Cập nhật phân quyền thành công!", "success").then(() => window.location.reload()); 
            })
            .catch(() => { 
                setShow(false); 
                swal(t('error'), "Có lỗi xảy ra", "error"); 
            });
    };

    const textFieldSx = {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#F9F9F9',
            height: '46px',
            '& fieldset': { borderColor: '#E4E6EF' },
            '&:hover fieldset': { borderColor: '#B5B5C3' },
            '&.Mui-focused fieldset': { borderColor: '#2563EB', borderWidth: '1px' },
        },
        '& .MuiInputBase-input': { 
            height: '46px', 
            padding: '0 14px', 
            boxSizing: 'border-box',
            fontSize: '0.9rem', 
            color: '#181C32', 
            fontWeight: 500, 
            fontFamily: "'Plus Jakarta Sans', sans-serif" 
        },
        '& select.MuiNativeSelect-select': {
            height: '46px', lineHeight: '46px', paddingTop: '0', paddingBottom: '0'
        }
    };

    const tableHeadSx = {
        color: "#A1A5B7 !important", fontWeight: "700 !important", fontSize: "0.75rem !important", 
        backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important",
        borderTop: "none !important", textTransform: "uppercase !important"
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={minimalistTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-employee-zone * { box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; text-align: left; }
                    `}</style>
                    
                    <Box className="safe-employee-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        <Container maxWidth="xl">
                            
                            {/* ================= FORM TẠO TÀI KHOẢN ================= */}
                            <Card sx={{ mb: 5, overflow: 'visible' }}>
                                <Box sx={{ p: 3, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="h5" fontWeight="800" color="#181C32" gutterBottom>{t("create_account")}</Typography>
                                    <Typography variant="body2" color="#7E8299" fontWeight="500">Thêm mới hệ thống Đại lý hoặc Nhân viên quản trị</Typography>
                                </Box>
                                
                                <CardContent sx={{ p: 4 }}>
                                    <form onSubmit={handleSubmit}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#3F4254", mb: 1, display: "block" }}>Tên đăng nhập <span style={{color:"#EF4444"}}>*</span></Typography>
                                                <TextField fullWidth name="username" placeholder="Nhập tên đăng nhập..." required sx={textFieldSx} />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#3F4254", mb: 1, display: "block" }}>Mật khẩu <span style={{color:"#EF4444"}}>*</span></Typography>
                                                <TextField fullWidth name="password" type="password" placeholder="Nhập mật khẩu..." required sx={textFieldSx} />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#3F4254", mb: 1, display: "block" }}>Mã giới thiệu</Typography>
                                                <TextField fullWidth name="code" placeholder="Mã giới thiệu (nếu có)" sx={textFieldSx} />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#3F4254", mb: 1, display: "block" }}>Loại tài khoản</Typography>
                                                <TextField select fullWidth value={type} onChange={handleChange} sx={textFieldSx} SelectProps={{ native: true }}>
                                                    <option value="customer">Đại lý</option>
                                                    <option value="admin">Nhân viên quản trị</option>
                                                </TextField>
                                            </Grid>

                                            {/* 🟢 PHÂN QUYỀN FORM TẠO MỚI THEO TỪNG MỤC (ROLE_LIST) */}
                                            {type === "admin" && (
                                                <Grid item xs={12}>
                                                    <Box sx={{ p: 3, backgroundColor: "#FFF", borderRadius: "8px", border: "1px solid #E4E6EF" }}>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32" mb={3}>
                                                            Phân quyền:
                                                        </Typography>
                                                        
                                                        {ROLE_LIST.map((group, groupIdx) => (
                                                            <Box key={groupIdx} sx={{ mb: groupIdx !== ROLE_LIST.length - 1 ? 3 : 0 }}>
                                                                <Typography variant="body2" sx={{ fontWeight: 800, color: "#2563EB", mb: 1.5, textTransform: "uppercase", fontSize: "0.78rem", letterSpacing: "0.5px" }}>
                                                                    {group.category}
                                                                </Typography>
                                                                <Grid container spacing={2}>
                                                                    {group.roles.map((role) => (
                                                                        <Grid item xs={6} sm={4} md={3} lg={2.4} key={role.name}>
                                                                            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontWeight: "600", color: "#3F4254", fontSize: "0.85rem" }}>
                                                                                <input 
                                                                                    type="checkbox" 
                                                                                    name={role.name}
                                                                                    style={{ width: "16px", height: "16px", accentColor: "#2563EB", cursor: "pointer" }} 
                                                                                    checked={roles[role.name] || false} 
                                                                                    onChange={handleRoleChange} 
                                                                                />
                                                                                {role.label}
                                                                            </label>
                                                                        </Grid>
                                                                    ))}
                                                                </Grid>
                                                                {groupIdx !== ROLE_LIST.length - 1 && <Divider sx={{ mt: 2.5, borderColor: '#EFF2F5' }} />}
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </Grid>
                                            )}

                                            <Grid item xs={12}>
                                                <Divider sx={{ my: 1, borderColor: '#EFF2F5' }} />
                                                <Box display="flex" justifyContent="flex-end" mt={2}>
                                                    <Button variant="contained" color="primary" type="submit" size="large" sx={{ px: 5, height: '46px', fontWeight: "700", boxShadow: "none", borderRadius: "8px", fontSize: "0.9rem" }}>
                                                        XÁC NHẬN TẠO MỚI
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>

                            {/* ================= BẢNG DANH SÁCH ĐẠI LÝ ================= */}
                            <Card sx={{ mb: 5 }}>
                                <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="subtitle1" fontWeight="800" color="#181C32">{t("agents")}</Typography>
                                    <TextField 
                                        onChange={requestSearch} placeholder="Tìm kiếm tài khoản..." size="small"
                                        InputProps={{
                                            startAdornment: <SearchIcon sx={{ color: '#A1A5B7', mr: 1, fontSize: '1.2rem' }} />,
                                            sx: { borderRadius: '6px', backgroundColor: '#F9F9F9', '& fieldset': { borderColor: '#E4E6EF' }, minWidth: '250px', fontSize: '0.85rem', height: '40px', fontWeight: '500' }
                                        }}
                                    />
                                </Box>
                                <TableContainer>
                                    <Table sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>ID</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("username")}</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("referrer_code")}</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("created")}</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>{t("more")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {users && users.map((item) => (
                                                <TableRow key={item._id} hover>
                                                    <TableCell sx={{ fontWeight: "600", pl: 3 }}>{item.iduser}</TableCell>
                                                    <TableCell sx={{ fontWeight: "800", color: "#2563EB" }}>{item.username}</TableCell>
                                                    <TableCell sx={{ fontWeight: "700" }}>{item.code}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", fontWeight: "500" }}>{formatDate(item.createdAt)}</TableCell>
                                                    <TableCell align="right" sx={{ pr: 3 }}>
                                                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                            <Button 
                                                                size="small"
                                                                sx={{ minWidth: '70px', textTransform: 'none', fontWeight: 700, backgroundColor: item.isLock ? '#DCFCE7' : '#FEE2E2', color: item.isLock ? '#16A34A' : '#EF4444', '&:hover': { backgroundColor: item.isLock ? '#16A34A' : '#EF4444', color: '#FFF' } }}
                                                                onClick={() => {
                                                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, { id: item._id, isLock: !item.isLock })
                                                                    .then(() => swal(`${item.isLock ? t("unlock") : t("lock")} thành công`, "", "success").then(() => window.location.reload()));
                                                                }}>
                                                                {item.isLock ? t("unlock") : t("lock")}
                                                            </Button>
                                                            <Button variant="outlined" size="small" sx={{ textTransform: 'none', fontWeight: '700' }} onClick={() => navigate(`/admin/employee/${item.code}`)}>Tuyến dưới</Button>
                                                            <Button variant="contained" size="small" sx={{ textTransform: 'none', boxShadow: 'none', fontWeight: '700' }} onClick={() => navigate(`/admin/user/${item._id}`)}>{t("view")}</Button>
                                                            <Button 
                                                                variant="contained" color="error" size="small" sx={{ textTransform: 'none', ml: 1, boxShadow: 'none' }}
                                                                onClick={() => {
                                                                    swal({
                                                                        title: "Xác nhận xóa?",
                                                                        text: `Bạn chắc chắn muốn xóa tài khoản: ${item.username}?`,
                                                                        icon: "warning",
                                                                        buttons: ["Hủy", "Xóa ngay"],
                                                                        dangerMode: true,
                                                                    }).then((willDelete) => {
                                                                        if (willDelete) {
                                                                            axios.post(`${process.env.REACT_APP_API_URL}/auth/deleteEmployee`, { id: item._id })
                                                                            .then(() => {
                                                                                swal("Thành công", "Đã xóa tài khoản!", "success");
                                                                                setUser(prev => prev.filter(u => u._id !== item._id));
                                                                                setData2(prev => prev.filter(u => u._id !== item._id));
                                                                            })
                                                                            .catch(() => swal("Lỗi", "Không thể xóa!", "error"));
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                Xóa
                                                            </Button>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {(!users || users.length === 0) && (
                                                <TableRow><TableCell colSpan={6} align="center" sx={{ py: 4, color: '#A1A5B7', fontWeight: '600' }}>Không có dữ liệu</TableCell></TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>

                            {/* ================= BẢNG DANH SÁCH NHÂN VIÊN ================= */}
                            <Card>
                                <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="subtitle1" fontWeight="800" color="#181C32">{t("staffs")}</Typography>
                                </Box>
                                <TableContainer>
                                    <Table sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>ID</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("username")}</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("referrer_code")}</TableCell>
                                                <TableCell sx={tableHeadSx}>Quyền quản trị</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("created")}</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>{t("more")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {nhanvien && nhanvien.map((item) => (
                                                <TableRow key={item._id} hover>
                                                    <TableCell sx={{ fontWeight: "600", pl: 3 }}>{item.iduser}</TableCell>
                                                    <TableCell sx={{ fontWeight: "800", color: "#181C32" }}>{item.username}</TableCell>
                                                    <TableCell sx={{ fontWeight: "700" }}>{item.code}</TableCell>
                                                    
                                                    {/* HIỂN THỊ CÁC NHÃN THEO QUYỀN */}
                                                    <TableCell>
                                                        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: '4px' }}>
                                                            {item.roles?.dashboard && <Chip label="Tổng quan" size="small" sx={{ backgroundColor: '#EFF6FF', color: '#2563EB', fontWeight: 700, borderRadius: '4px' }} />}
                                                            {(item.roles?.recharge || item.roles?.withdraw) && <Chip label="Giao dịch" size="small" sx={{ backgroundColor: '#DCFCE7', color: '#16A34A', fontWeight: 700, borderRadius: '4px' }} />}
                                                            {(item.roles?.user_customer || item.roles?.user_admin) && <Chip label="Users" size="small" sx={{ backgroundColor: '#FEF3C7', color: '#F59E0B', fontWeight: 700, borderRadius: '4px' }} />}
                                                            
                                                            {/* ĐÃ CẬP NHẬT THÊM ĐIỀU KIỆN HIỂN THỊ CHIP GAME CHO BACCARAT */}
                                                            {(item.roles?.game_tx45 || item.roles?.game_tx60 || item.roles?.game_xd45 || item.roles?.game_xd60 || item.roles?.game_xs75 || item.roles?.game_xs120 || item.roles?.game_baccarat) && <Chip label="Game" size="small" sx={{ backgroundColor: '#FEE2E2', color: '#EF4444', fontWeight: 700, borderRadius: '4px' }} />}
                                                            
                                                            {(item.roles?.hist_bet || item.roles?.hist_api || item.roles?.hist_refund) && <Chip label="Lịch sử" size="small" sx={{ backgroundColor: '#F3E8FF', color: '#7C3AED', fontWeight: 700, borderRadius: '4px' }} />}
                                                            {(item.roles?.sys_promo || item.roles?.sys_notify || item.roles?.sys_withdraw || item.roles?.sys_odds || item.roles?.sys_vip || item.roles?.sys_bank || item.roles?.sys_config) && <Chip label="Hệ thống" size="small" sx={{ backgroundColor: '#E0E7FF', color: '#9333EA', fontWeight: 700, borderRadius: '4px' }} />}
                                                            
                                                            {(!item.roles || Object.values(item.roles).every(v => v === false)) && <Typography variant="caption" color="text.secondary" fontWeight="600">Chưa cấp quyền</Typography>}
                                                        </Stack>
                                                    </TableCell>

                                                    <TableCell sx={{ color: "text.secondary", fontWeight: "500" }}>{formatDate(item.createdAt)}</TableCell>
                                                    <TableCell align="right" sx={{ pr: 3 }}>
                                                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                            <Button 
                                                                size="small"
                                                                sx={{ minWidth: '70px', textTransform: 'none', fontWeight: 700, backgroundColor: item.isLock ? '#DCFCE7' : '#FEE2E2', color: item.isLock ? '#16A34A' : '#EF4444', '&:hover': { backgroundColor: item.isLock ? '#16A34A' : '#EF4444', color: '#FFF' } }}
                                                                onClick={() => {
                                                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, { id: item._id, isLock: !item.isLock })
                                                                    .then(() => swal(`${item.isLock ? t("unlock") : t("lock")} thành công`, "", "success").then(() => window.location.reload()));
                                                                }}>
                                                                {item.isLock ? t("unlock") : t("lock")}
                                                            </Button>

                                                            {/* NÚT MỞ MODAL PHÂN QUYỀN */}
                                                            <Button variant="outlined" size="small" sx={{ textTransform: 'none', fontWeight: '700' }} 
                                                                onClick={() => { 
                                                                    setLs(item); 
                                                                    const currentRoles = item.roles || {};
                                                                    setEditRoles(currentRoles);
                                                                    setShow(true); 
                                                                }}>
                                                                Phân quyền
                                                            </Button>

                                                            <Button variant="contained" size="small" sx={{ textTransform: 'none', boxShadow: 'none', fontWeight: '700' }} onClick={() => navigate(`/admin/user/${item._id}`)}>{t("view")}</Button>
                                                            <Button 
                                                                variant="contained" color="error" size="small" sx={{ textTransform: 'none', ml: 1, boxShadow: 'none' }}
                                                                onClick={() => {
                                                                    swal({
                                                                        title: "Xác nhận xóa?",
                                                                        text: `Bạn chắc chắn muốn xóa tài khoản: ${item.username}?`,
                                                                        icon: "warning",
                                                                        buttons: ["Hủy", "Xóa ngay"],
                                                                        dangerMode: true,
                                                                    }).then((willDelete) => {
                                                                        if (willDelete) {
                                                                            axios.post(`${process.env.REACT_APP_API_URL}/auth/deleteEmployee`, { id: item._id })
                                                                            .then(() => {
                                                                                swal("Thành công", "Đã xóa tài khoản!", "success");
                                                                                setNhanvien(prev => prev.filter(u => u._id !== item._id));
                                                                            })
                                                                            .catch(() => swal("Lỗi", "Không thể xóa!", "error"));
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                Xóa
                                                            </Button>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {(!nhanvien || nhanvien.length === 0) && (
                                                <TableRow><TableCell colSpan={6} align="center" sx={{ py: 4, color: '#A1A5B7', fontWeight: '600' }}>Không có dữ liệu</TableCell></TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>

                        </Container>
                        
                        {/* ================= MODAL SỬA PHÂN QUYỀN MỚI (CHIA CỤM THEO ROLE_LIST) ================= */}
                        {isShow === true && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Card sx={{ width: '650px', maxHeight: '90vh', overflowY: 'auto', p: 4 }}>
                                    <Typography variant="h6" fontWeight="800" mb={1}>{t("permission")} - <span style={{color: '#2563EB'}}>{ls?.username}</span></Typography>
                                    <Typography variant="body2" color="text.secondary" mb={3}>Tích chọn các chức năng bạn muốn cho phép nhân viên này truy cập.</Typography>
                                    
                                    <form onSubmit={handleSubmitLs}>
                                        <Box sx={{ p: 3, backgroundColor: "#FFF", borderRadius: "8px", border: "1px solid #E4E6EF", mb: 3 }}>
                                            {ROLE_LIST.map((group, groupIdx) => (
                                                <Box key={groupIdx} sx={{ mb: groupIdx !== ROLE_LIST.length - 1 ? 3 : 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 800, color: "#2563EB", mb: 1.5, textTransform: "uppercase", fontSize: "0.78rem", letterSpacing: "0.5px" }}>
                                                        {group.category}
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        {group.roles.map((role) => (
                                                            <Grid item xs={6} sm={4} key={role.name}>
                                                                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontWeight: "600", color: "#3F4254", fontSize: "0.85rem" }}>
                                                                    <input 
                                                                        type="checkbox" 
                                                                        name={role.name}
                                                                        style={{ width: "18px", height: "18px", accentColor: "#2563EB", cursor: "pointer" }} 
                                                                        checked={editRoles[role.name] || false} 
                                                                        onChange={handleEditRoleChange} 
                                                                    />
                                                                    {role.label}
                                                                </label>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                    {groupIdx !== ROLE_LIST.length - 1 && <Divider sx={{ mt: 2.5, borderColor: '#EFF2F5' }} />}
                                                </Box>
                                            ))}
                                        </Box>
                                        
                                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                                            <Button variant="outlined" color="inherit" onClick={() => setShow(false)} sx={{fontWeight: '700', px: 4}}>{t("close")}</Button>
                                            <Button variant="contained" type="submit" sx={{ boxShadow: 'none', fontWeight: '700', px: 4 }}>CẬP NHẬT QUYỀN</Button>
                                        </Stack>
                                    </form>
                                </Card>
                            </Box>
                        )}

                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default AllEmployee;